<template>
    <article class="home-page-article">
        <h2 class="home-page-article__title">
            {{ title }}
        </h2>
        <CollapsedText
            :sneak-peak="shortDescription"
            :main-text="description"
            class="home-page-article__text"
        />
    </article>
</template>

<script>
import CollapsedText from '~/components/common/Text/CollapsedText';

export default {
    name: 'ArticleBlock',
    components: { CollapsedText },
    props: {
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        shortDescription: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss">
    .home-page-article {
        &__title {
            width: 100%;
            padding: 0 0 20px 0;
            text-align: center;
            font: $font-weight-bold 24px/24px $goodHomeFontFamily;
            color: $color-slate100;
        }

        &__text {
            text-align: center;
            font: $font-weight-light 14px/18px $goodHomeFontFamily;
            color: $color-slate100;

            p {
                text-align: justify;
                margin: 0 0 32px 0;
                padding: 0;
            }
        }
    }

    @media (max-width: $breakpoint-tablet) {
        .home-page-article {
            &__title {
                text-align: left;
            }

            &__text {
                text-align: left;
            }
        }
    }

</style>
